// extracted by mini-css-extract-plugin
module.exports = {"selector":"bx_hk","selectorButton":"bx_hl","menuContainer":"bx_hm","menu":"bx_hn","darkMode":"bx_cN","available":"bx_hp","active":"bx_bH","coming":"bx_hq","sectionTitle":"bx_8"};